module.exports = __webpack_public_path__ + "img/Roboto-Black.105556fd.svg";